import { Component, Input, OnInit } from '@angular/core';
import Enumerable from 'linq';
import { Enums } from 'src/app/_models/generatedEnums';
import { PageElementViewModel, ConferenceViewModel, EventOrderBy, EventSearchParameters, EventViewModel, OrganizationEventSearchParams, ConferenceRoomViewModel, TagViewModel } from 'src/app/_models/generatedModels';
import { EventService, OrganizationService } from 'src/app/_services/generatedServices';


@Component({
  selector: 'bxl-conference-event-listing',
  templateUrl: 'conference-event-listing.component.html',
})
export class ConferenceEventListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  events: EventViewModel[];
  searchParams: OrganizationEventSearchParams;
  EventOrderBy = EventOrderBy;
  OrderByEnum = Enums.EventOrderByEnum;

  currentPage = 0;
  pageSize = 15;
  resultCount = 0;
  searching = false;
  startTimes: Enumerable.IGrouping<string, EventViewModel>[];
  rooms: ConferenceRoomViewModel[];
  tags: TagViewModel[];
  hideFilter: boolean;
  constructor(private orgService: OrganizationService) {}

  ngOnInit(): void {
    this.searchParams = new OrganizationEventSearchParams();
    this.searchParams.courseEventStatus = null;
    this.searchParams.orderBy = EventOrderBy.EventDate;
    this.searchParams.roomId = null;
    this.searchParams.tag = null;

    this.orgService.getRoomsForConference(this.conference.id.toString()).subscribe((rooms) => {
      this.orgService.getTagsForConference(this.conference.id).subscribe((tags) => {
        this.rooms = rooms;
        this.tags = tags;

        console.log(this.element.data);

        if (this.element.data) {
          try {
            var data = JSON.parse(this.element.data);
            console.log(data?.tag);
            this.searchParams.selectedDay = data?.selectedDay;
            this.searchParams.selectedTime = data?.selectedTime;
            this.searchParams.tag = data?.tag;

            if (this.searchParams.selectedDay || this.searchParams.selectedTime || this.searchParams.tag) {
              this.hideFilter = true;
            }

          } catch (e) {
            console.log('error');
            this.searchParams.selectedDay = null;
          }
        } else {
          this.searchParams.selectedDay = null;
        }

        this.search(true);

      });
    });
  }

  search(resetPaging: boolean) {
    this.searching = true;
    if (resetPaging) {
      this.currentPage = 0;
    }
    this.events = [];

    this.orgService.searchEventsForConference(this.conference.id, this.currentPage, this.pageSize, true, this.searchParams).subscribe((pagedResult) => {
      this.currentPage = pagedResult.currentPage;
      this.pageSize = pagedResult.pageSize;
      this.resultCount = pagedResult.rowCount;
      this.events = pagedResult.results;

      this.initialized = true;
      this.searching = false;
    });
  }

  paginate(event) {
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.currentPage = event.page;
    this.pageSize = event.rows;
    this.search(false);
  }
}
